var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPkPakistan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7559 0H-3.74414V45H63.7559V0Z",
    fill: "#0C590B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7559 0H46.8369V45H63.7559V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9248 19.8105L22.667 19.2305L24.1084 21.6299L24.4072 18.8525L27.1318 18.2197L24.583 17.0771L24.8203 14.291L22.9395 16.3652L20.3643 15.2754L21.7617 17.7012L19.916 19.8105H19.9248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8965 26.8945C19.4814 28.1709 20.3129 29.319 21.3431 30.2729C22.3732 31.2268 23.5818 31.9676 24.8993 32.4528C26.2168 32.938 27.6172 33.1579 29.02 33.1C30.4228 33.0421 31.8003 32.7074 33.0733 32.1152C35.656 30.9194 37.658 28.7466 38.6387 26.0748C39.6194 23.4029 39.4986 20.4509 38.3028 17.8682C37.7089 16.5405 36.8438 15.3518 35.763 14.3785C34.6823 13.4052 33.4098 12.6689 32.0274 12.2168C32.3893 12.5181 32.7354 12.8379 33.0645 13.1748C34.7792 15.0738 35.6895 17.5646 35.6034 20.1218C35.5173 22.679 34.4415 25.1028 32.6028 26.8821C30.7642 28.6615 28.3064 29.6573 25.7478 29.6596C23.1891 29.662 20.7296 28.6706 18.8877 26.8945H18.8965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPkPakistan);
export default __webpack_public_path__ + "static/media/pk Pakistan.2051c29bf664deaf08f80718c4a4690b.svg";
export { ForwardRef as ReactComponent };